// extracted by mini-css-extract-plugin
export default {"wrapper":"_53f6d3f0","expandBtn":"_52db445d","cta":"_e918015","addMarginTop":"_ac6c6df7","paragraph":"_be543ccd"};